import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';

// Get language from URL parameter
const getLanguageFromURL = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get('lang');
};

// Get language from localStorage
const getLanguageFromStorage = (): string | null => {
  return localStorage.getItem('i18nextLng');
};

// Determine initial language
const getInitialLanguage = (): string => {
  const urlLang = getLanguageFromURL();
  if (urlLang && (urlLang === 'en' || urlLang === 'de')) {
    // Save to localStorage
    localStorage.setItem('i18nextLng', urlLang);
    return urlLang;
  }
  
  const storedLang = getLanguageFromStorage();
  if (storedLang && (storedLang === 'en' || storedLang === 'de')) {
    return storedLang;
  }
  
  // Fallback to browser language or English
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'de' ? 'de' : 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      de: {
        translation: deTranslations,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Listen for URL changes
const updateLanguageFromURL = () => {
  const urlLang = getLanguageFromURL();
  if (urlLang && (urlLang === 'en' || urlLang === 'de')) {
    i18n.changeLanguage(urlLang);
    localStorage.setItem('i18nextLng', urlLang);
  }
};

// Check URL on load
updateLanguageFromURL();

// Listen for popstate (back/forward navigation)
window.addEventListener('popstate', updateLanguageFromURL);

export default i18n;

